<template>
<section id="about" class="section about-me" style="background-image: url(images/bg_x20.png);" >
  <div class="heading">
    <h2>About Me</h2>
    <p data-aos="fade-up">Know Me More</p>
  </div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 col-lg-6" data-aos="fade-up">
        <div class="about-info-text">
          <h2>I'm <span>Mohammad Ali</span>, a Information Technology Engineer</h2>
          <p>Engineer Mohamed Ali, specializing in software engineering and information systems, I work remotely. I adopt all the requirements and needs of the market from private and public software projects, as I provide a service for developing websites,
            mobile and desktop applications, and solving software problems.</p>
          <p>I always strive to be the best and my goal is to be at the top of the software industry with the highest quality and lowest prices in the Middle East.</p>
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <div class="about-info" data-aos="fade-up">
          <ul>
            <li><i class="fa-solid fa-user-tie"></i><span>Name: </span> Mohammad Ali</li>
            <li><i class="fa-solid fa-envelope-open"></i><span>Email: </span> <a href="mailto:mohammadanouali@gmail.com">mohammadanouali@gmail.com</a></li>
            <li><i class="fa-solid fa-calendar"></i><span>Date Of Birth: </span> 1995</li>
            <li><i class="fa-solid fa-person-military-rifle"></i><span>Military Service: </span> No military service</li>
            <li><i class="fa-solid fa-map-marker"></i><span>From: </span> Syria - Damascus</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
</template>

<script>
export default {
  name: "VueAboutME"
}
</script>

<style scoped>
.about-me{
  padding: 50px 0;
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
}
.about-info-text{
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.about-info-text h2{
  font-weight: 600;
  font-size: 28px;
}
.about-info-text h2 span{
  color: var(--primary-color);
}
.about-info-text p{
  font-weight: 400;
  font-size: 18px;
}
.about-info{
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: center;
}
.about-info ul{
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  margin: 0;
  padding: 0;
  width: max-content;
}
.about-info ul li{
  list-style: none;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;
  font-weight: 400;
  font-size: 18px;
  border-bottom: 1px solid rgba(250, 250, 250, 0.12);
  padding-top: 7px;
  padding-bottom: 7px;

}
.about-info ul li a{
  color: var(--primary-color);
}
.about-info ul li a:hover{
  color: var(--primary-color);
  opacity: 0.8;
}
@media (max-width: 991px) {
  .about-info{
    display: flex;
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }
}
</style>